import { getActiveBuildings } from "./index24.js";
import { setBuildingPolys } from "@project-rouge/rg-three";
const pipeGeneratePolygons = ([parent, { buildingIds, aggProps }]) => {
	const dataset = aggProps.dataset;
	const buildings = getActiveBuildings(parent, aggProps);
	for (const building of buildings) {
		if (buildingIds && !buildingIds.includes(building.uuid)) continue;
		setBuildingPolys(building, dataset);
	}
	return [parent, void 0];
};
export { pipeGeneratePolygons };

//# sourceMappingURL=index177.js.map